/**
 * The platform's Vega charting surface.
 *
 * Import from here rather than from the files behind it, and never from
 * ``react-vega``/``vega-embed`` directly: {@link VegaChart} is the only thing
 * that should know which react-vega version is installed or how it is wired.
 */

export { default as VegaChart, type ChartSpec } from './VegaChart';
export { formatAssuranceChartTooltip } from './assuranceTooltip';
export { default as DonutChart } from './DonutChart';
export { default as StackedBarChart } from './StackedBarChart';
export { default as BarChart } from './BarChart';
export { AXIS_INK, CATEGORY_LABEL_LIMIT, CHART_FONT, GRID_INK, LABEL_INK, REVERSED_LABEL_INK } from './vegaTheme';
